import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Client from '@/model/entity/client/client';
import Decimal from 'big.js';
import LocaleHelper from '@vertical-plus/vue-js-core/dist/util/i18n/locale-helper';
import ServiceDataTableReport from '@/model/service/billing/report/service-data-table-report';

@Component
export default class ServiceIndex extends Vue
{
    @Prop({
        type: Object,
        default: null,
    })
    private client!: Client;

    $refs!:
    {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dataTable: any,
    };

    protected report: ServiceDataTableReport|null = null;

    private created()
    {
        this.report = new ServiceDataTableReport(this.$serviceContainer, this.client);
    }

    @Watch('client')
    private onClientChanged()
    {
        if (!this.report)
        {
            return;
        }

        this.report.setClient(this.client);
        this.$refs.dataTable.reload();
    }

    private formattedAmount(amount: Decimal): string
    {
        return LocaleHelper.formatCurrency(
            amount,
            2,
            'GBP',
        );
    }
}